import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedAnnouncement = () => {
  return {
    title: "",
    detail: "",
    showInSlider: false,
    showInAnnouncement: false,
    sliderImageUrl: "",
    imageUrl: "",
    sliderOrder: null,
    announcementOrder: null,
  };
};

export default {
  state: () => ({
    selectedAnnouncement: getDefaultSelectedAnnouncement(),
  }),
  mutations: {
    setSelectedAnnouncement(state, announcement) {
      Vue.set(state, "selectedAnnouncement", announcement);
    },
    setDefaultSelectedAnnouncement(state) {
      Vue.set(state, "selectedAnnouncement", getDefaultSelectedAnnouncement());
    },
  },
  actions: {
    createAnnouncement: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/announcements/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    // Yalnızca yayındaki kayıtlar; b2c'de gerçekten görünen liste bu.
    // Sıra alanı boş bırakıldığında kaydın kaçıncı sıraya düşeceğini hesaplamak için kullanılıyor.
    loadPublishedAnnouncements: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/entity/published").then((response) => {
        return Array.isArray(response.data) ? response.data : [];
      });
    },
    loadAnnouncements: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/announcements/entity").then((response) => {
        return response.data;
      });
    },
    loadAnnouncement: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/entity/" + request.id).then((response) => {
        context.commit("setSelectedAnnouncement", response.data);
        return response.data;
      });
    },
    loadSelectedAnnouncementHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteAnnouncement: (context, announcement) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/announcements/entity/" + announcement.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          announcement.intents = intents;
          announcement.intentId = response.data.id;
          return announcement;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    deleteDraftAnnouncement: (context, announcement) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/announcements/draft/" + announcement.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishAnnouncement: (context, announcement) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/publish/" + announcement.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectAnnouncement: (context, announcement) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/reject/" + announcement.intentId).then((response) => {
        if (announcement.intents[0].type === "DELETE_ANNOUNCEMENT") {
          announcement.intents = null;
          announcement.intentId = 0;
        } else if (announcement.intents[0].type === "CREATE_ANNOUNCEMENT") {
          announcement.intents[0].status = "DRAFT";
        } else if (announcement.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          announcement.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalAnnouncement: (context, announcement) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/sendToApproval/" + announcement.intentId).then((response) => {
        if (announcement.intents[0].type === "CREATE_ANNOUNCEMENT") {
          announcement.intents[0].status = "WAITING_APPROVAL";
        } else if (announcement.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          announcement.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallAnnouncement: (context, announcement) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/recall/" + announcement.intentId).then((response) => {
        helper.recallOrRejectEntity(announcement, "announcement");
        return response.data;
      });
    },

    cancelAnnouncement: (context, announcement) => {
      return axios.get(context.getters.getMcServiceUrl + "/announcements/cancel/" + announcement.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedAnnouncement: (state) => {
      return state.selectedAnnouncement;
    },
  },
};
